import moment from "moment"
import { storageListSelect, staffListSelect, getDetailsMethod, listByProductSkuId, productCode } from "@/utils/api"
export const method = {
    data() {
        return {
            warehouseList: [], // 出库仓库列表
            agentList: [], // 经办人列表
            dataSource: [],
            inputData: {
                productName: '',
                productCode: ''
            },
            dateValue: null,
            formData: {
                code: '', // 单据单号
                voucherDate: undefined, // 单据日期
                contactCustomerId: '', // 往来单位id
                contactCustomerName: '', // 往来单位名称
                outStorageId: '', // 发货仓库id
                outStorageName: undefined, // 发货仓库名称
                transactorId: '', // 经办人id
                transactorName: undefined, // 经办人名称
                digest: '', // 摘要
                remark: '', // 备注
                attachmentFlag: 0, // 是否有附件 0否 1是
                attachmentResourceIdList: [], // 附件id列表
                attachmentResourceList: [], // 附件列表
                salesPriceItemVOList: [], // 选择商品
                distributionMode: '2', // 1客户自提 2送货上门
                logisticsCompanyId: '', // 物流id
                logisticsCompanyName: '', // 物流公司名称
                includeFreightFlag: 0, // 是否包含运费0否 1是,可用值:0,1
                logisticsCollectionFlag: '0', // 是否是物流代收 0否 1是,可用值:0,1
                trackingNumber: '', // 运输单号
                discountAmount: null, // 优惠金额
                otherExpensesAmount: null, // 加收运费
                salesOrderOtherExpensesVOList: [], // 订单加收
                salesPriceOtherExpensesVOList: [], // 加收项目
                totalAmount: 0, // 小计金额
                productTotalCount: 0,
            },
            voucherDate: undefined,

            skuIdList: [], // sku id数组
            footerDataSource: [],
            includeFreightFlag: true, // 是否包含运费
            productPresellPriceFieldName: '', // 预设售价

            totalAmount: 0,
            selectVoucherId: [],
            contentHeight: '',
            tableHeight: '', // 表格高度
            tdIndex: null, // 记录初始输入框的位置
            isShowList: false, // 记录是都显示过导入商品选择列表
            isEvent: false,
            isWarehouseOpen: false,
            isTransactorNameOpen: false
        }
    },
    // 实时控制页面布局
    created() {
        window.addEventListener('resize', this.calculateTableHeight)
    },
    beforeDestroy: function () {
        window.removeEventListener('resize', this.calculateTableHeight)
    },
    methods: {
        /**
         * 方法说明：页面初始化
         * @method init
         */
        init() {
            this.getDataSource(1)  // 获取初始表格
            this.calculateTableHeight() // 表格高度计算
            this.getCurrentData() // 获取单据日期
            this.getStorageList() // 获取仓库列表
            this.getStaffListSelect() // 获取经办人列表
            this.tableAddTotalRow(this.columns, this.dataSource) // 表格数据导入
        },
        /**
         * 方法说明：获取初始表格
         * @method getDataSource
         */
        getDataSource(type) {
            if (this.dataSource.length <= 0 && type==1 || this.dataSource.length > 0 && type==2) {
                this.dataSource = []
                for (let i = this.dataSource.length; i < 18; i++) {
                    this.dataSource.push({
                        serialNum: i,
                        status: 1,
                        statusCode: 1
                    })
                }
            }
        },
        /**
         * 方法说明：表格高度计算
         * @method calculateTableHeight
         */
        calculateTableHeight() {
            let _that = this
            setTimeout(function () {
                let tdHeight = document.getElementsByTagName('tr')[0].offsetHeight
                let header = document.getElementById("header").offsetHeight;
                let breadcrumb = document.getElementById("breadcrumb").offsetHeight;
                let pageHeight = document.getElementById('content').offsetHeight
                let makeTop = document.getElementById('page-top').offsetHeight
                let makeButton = document.getElementById('page-button').offsetHeight
                _that.contentHeight = pageHeight - makeTop - makeButton - header - breadcrumb - tdHeight * 1.24
                _that.tableHeight = _that.contentHeight - tdHeight * 2
            }, 50)
        },
        /**
         * 方法说明：表格增加合计行 
         * @method tableAddTotalRow
         */
        tableAddTotalRow(columns, dataSource) {
            let numKey = 'rowIndex'
            let totalRow = {
                [numKey]: '小计'
            }
            this.footerDataSource = [] // 表格最后一行数据
            columns.forEach(column => {
                let { key, dataIndex } = column
                if (![key, dataIndex].includes(numKey)) {
                    let total = 0
                    dataSource.forEach(data => {
                        if (dataIndex == 'totalAmount') {
                            if (data[dataIndex]) {
                                total += Number(data[dataIndex])
                            }
                        } else if (dataIndex == 'productTotalCount') {
                            if (data[dataIndex]) {
                                total += Number(data[dataIndex])
                            }
                        } else {
                            total = ''
                        }
                    })
                    totalRow[dataIndex] = total
                }
            })
            totalRow.totalAmount = totalRow.totalAmount.toFixed(2)
            this.CalculationAmount(totalRow)
            this.footerDataSource.push(totalRow)
        },

        /**
         * 方法说明：设置时间
         * @method getCurrentData
         */
        getCurrentData() {
            let date = this.$comm.getNowFormatDate()
            this.voucherDate = moment(date)
            this.formData.voucherDate = date
        },
        /**
         * 方法说明：选择日期
         * @method onChangeDate
         * @param {Object,String} date-时间moment, dateString-时间字符串
         */
        onChangeDate(date, dateString) {
            this.voucherDate = moment(dateString)
            this.formData.voucherDate = dateString
        },
        /**
         * 方法说明：打开选择往来单位的弹框
         * @method btnReceiptModel
         */
        btnReceiptModel() {
            if (!this.isEvent) {
                this.$refs.receipt.onOpen(this.formData.contactCustomerName)
            }
        },
        /**
         * 方法说明：选择往来单位
         * @method onSelectModel
         * @param {Object} date-选择往来单位后的回调参数
         */
        onSelectModel(data) {
            // 判断是否选择了往来单位
            if (this.formData.contactCustomerId) {
                // 判断是否选择了相同的往来单位
                if (this.formData.contactCustomerId == data.id) {
                    this.formData.contactCustomerId = data.id
                    this.formData.contactCustomerName = data.contactCustomerName
                } else {
                    // 选择不同往来单位对已选择的商品进行清空设置
                    let goodsList = []
                    this.formData.contactCustomerId = data.id
                    this.formData.contactCustomerName = data.contactCustomerName
                    this.dataSource.map((item, index) => {
                        if (item.contactCustomerId && this.formData.contactCustomerId != item.contactCustomerId) { 
                            // console.log(item)
                        } else {
                            goodsList.push(item)
                        }
                    })
                    if (goodsList.length < 9) { // 在数据未满8条的情况下添加空白
                        for (let i = goodsList.length; i < 9; i++) {
                            goodsList.push({
                                id: 'jqy2020' + i,
                                status: 1
                            })
                        }
                    } else {
                        goodsList.push({
                            id: 'jqykj2020',
                            status: 1
                        })
                    }
                    this.dataSource = goodsList
                }
            } else {
                this.formData.contactCustomerId = data.id
                this.formData.contactCustomerName = data.contactCustomerName
            }
            document.getElementById('steps-01').focus() // 焦点自动聚焦到下一个输入框
            this.isWarehouseOpen = true
            setTimeout(function () {
                document.getElementById('steps-02').focus()
            }, 10);
        },
        /**
         * 方法说明：获取仓库列表
         * @method getStorageList
         */
        getStorageList() {
            let params = new FormData()
            params.append("companyStoreId", this.$store.state.userInfo.companyStoreId)
            storageListSelect(params).then((res) => {
                if (res.code == 200) {
                    this.warehouseList = res.result
                    let storageNameData = JSON.parse(localStorage.getItem('outStorageName'))
                    if (storageNameData && !this.$route.query.id) {
                        this.formData.outStorageId = storageNameData.outStorageId
                        this.formData.outStorageName = storageNameData.outStorageName
                    }
                } else {
                    this.$message.error(res.logMessage)
                }
            })
        },
        /**
         * 方法说明：选择仓库
         * @method selectWarehouse
         * @param {Number} e-仓库列表数据的下标
         */
        selectWarehouse(e) {
            this.isWarehouseOpen = false
            this.formData.outStorageId = this.warehouseList[e].id
            this.formData.outStorageName = this.warehouseList[e].storageName
            localStorage.setItem('outStorageName', JSON.stringify({
                outStorageId: this.formData.outStorageId,
                outStorageName: this.formData.outStorageName
            }))
        },
        /**
         * 方法说明：选择关闭选择库位下拉框
         * @method addItemWarehouse
         */
        addItemWarehouse() {
            this.$router.push({ path: '/librarymanage/warehouse/warehouse' })
        },

        /**
         * 方法说明：获取经办人列表
         * @method getStaffListSelect
         */
        getStaffListSelect() {
            let params = new FormData()
            params.append("companyStoreId", this.$store.state.userInfo.companyStoreId)
            staffListSelect(params).then((res) => {
                if (res.code == 200) {
                    this.agentList = res.result
                    let transactorNameData = JSON.parse(localStorage.getItem('transactorName'))
                    if (transactorNameData && !this.$route.query.id) {
                        this.formData.transactorId = transactorNameData.transactorId
                        this.formData.transactorName = transactorNameData.transactorName
                    }
                } else {
                    this.$message.error(res.logMessage)
                }
            })
        },
        /**
         * 方法说明：选择经办人
         * @method selectAgentList
         * @param {Number} e-经办人列表数据的下标
         */
        selectAgentList(e) {
            this.isTransactorNameOpen = false
            this.formData.transactorId = this.agentList[e].id
            this.formData.transactorName = this.agentList[e].name
            localStorage.setItem('transactorName', JSON.stringify({
                transactorId: this.formData.transactorId,
                transactorName: this.formData.transactorName
            }))
        },

        /**
         * 方法说明：备注信息输入完毕后回车焦点自动聚焦到选择的商品名称表格上
         * @method pressEnterRemark
         */
        pressEnterRemark() {
            if (this.dataSource[0].status == 1) {
                let text = ''
                let record = {
                    status: 1
                }
                let index = 0
                this.btnChangeState(text, record, index)
            } else {
                let text = ''
                let record = {
                    status: 1
                }
                let index = 0
                for (let i = 0; i < this.dataSource.length; i++) {
                    if (this.dataSource[i].status == 1) {
                        index = i
                        break
                    }
                }
                this.btnChangeState(text, record, index)
            }
        },

        /**
         * 方法说明：浮动到选择仓库
         * @method mouseenterWarehouseOpen
         */
        // mouseenterWarehouseOpen() {
        //     document.getElementById('steps-02').focus()
        //     this.isWarehouseOpen = true
        // },
        // 仓库失去焦点事件
        // blurWarehouseOpen() {
        //     this.isWarehouseOpen = false
        // },

        /**
         * 方法说明：浮动到选择仓库
         * @method mouseenterTransactorNameOpen
         */
        // mouseenterTransactorNameOpen() {
        //     document.getElementById('steps-03').focus()
        //     this.isTransactorNameOpen = true
        // },
        /**
         * 方法说明：仓库失去焦点事件
         * @method blurTransactorNameOpen
         */
        blurTransactorNameOpen() {
            this.isTransactorNameOpen = false
        },

        /**
         * 方法说明：上传附件
         * @method onChangeFile
         * @param {object} data-上传附件的回调
         */
        onChangeFile(data) {
            this.formData.attachmentResourceIdList = []
            if (data.length > 0) {
                this.formData.attachmentFlag = 1
                data.map(item => {
                    if (item.orderId) {
                        this.formData.attachmentResourceIdList.push(item.resourceId)
                    } else {
                        this.formData.attachmentResourceIdList.push(item.id)
                    }
                })
            } else {
                this.formData.attachmentFlag = 0
            }
        },

        /**
         * 方法说明：点击表格商品名称，使表格变为输入框状态从而选择或更改商品
         * @method btnChangeState
         * @param {String,Object,Number} text-属性值，record-商品信息，index-商品数组下标
         */
        btnChangeState(text, record, index) {
            // 判断商品名称表格是否为空白——status：0——商品名称表格空白；1——商品名称表格有值；2——商品名称表格为输入框
            if (record.status == 0) {
                // 判断此次点击的商品名称表格是否和上次点击的是否是同一个
                if (this.tdIndex == index || this.tdIndex == null) {
                    this.inputData.productName = text
                    this.dataSource[index].status = 2
                    this.tdIndex = index
                } else {
                    this.inputData.productName = text
                    this.dataSource[index].status = 2
                    if (this.dataSource[this.tdIndex].productName) {
                        this.dataSource[this.tdIndex].status = 0
                    } else {
                        this.dataSource[this.tdIndex].status = 1
                    }
                    this.tdIndex = index
                }
            } else if (record.status == 1) {
                // 判断此次点击的商品名称表格是否和上次点击的是否是同一个
                if (this.tdIndex == index || this.tdIndex == null) {
                    this.dataSource[index].status = 2
                    this.tdIndex = index
                } else {
                    this.dataSource[index].status = 2
                    if (this.dataSource[this.tdIndex].productName) {
                        this.dataSource[this.tdIndex].status = 0
                    } else {
                        this.dataSource[this.tdIndex].status = 1
                    }
                    this.tdIndex = index
                }
            }
            this.dataSource.map((item, index) => { // 点击商品名称表格的时候自动将商品编号表格的输入框变为文本
                if (!item.productName) {
                    this.dataSource[index].statusCode = 1
                }
            })
            this.setInputSelectState(0)
        },
        /**
         * 方法说明：点击表格商品编号，使表格变为输入框状态从而选择或更改商品
         * @method btnChangeCodeState
         * @param {String,Object,Number} text-属性值，record-商品信息，index-商品数组下标
         */
        btnChangeCodeState(text, record, index) {
            // 判断商品编号表格是否为空白——status：0——商品编号表格空白；1——商品编号表格有值；2——商品编号表格为输入框
            if (record.statusCode == 0) {
                // 判断此次点击的商品编号表格是否和上次点击的是否是同一个
                if (this.tdCodeIndex == index || this.tdIndex == null) {
                    this.inputData.productCode = text
                    this.dataSource[index].statusCode = 2
                    this.tdCodeIndex = index
                } else {
                    this.inputData.productCode = text
                    this.dataSource[index].statusCode = 2
                    if (this.dataSource[this.tdCodeIndex].productCode) {
                        this.dataSource[this.tdCodeIndex].statusCode = 0
                    } else {
                        this.dataSource[this.tdCodeIndex].statusCode = 1
                    }
                    this.tdCodeIndex = index
                }
            } else if (record.statusCode == 1) {
                // 判断此次点击的商品编号表格是否和上次点击的是否是同一个
                if (this.tdCodeIndex == index || this.tdCodeIndex == null) {
                    this.dataSource[index].statusCode = 2
                    this.tdCodeIndex = index
                } else {
                    this.dataSource[index].statusCode = 2
                    if (this.dataSource[this.tdCodeIndex].productCode) {
                        this.dataSource[this.tdCodeIndex].statusCode = 0
                    } else {
                        this.dataSource[this.tdCodeIndex].statusCode = 1
                    }
                    this.tdCodeIndex = index
                }
            }
            this.dataSource.map((item, index) => { // 点击商品编号表格的时候自动将商品编号表格的输入框变为文本
                if (!item.productName) {
                    this.dataSource[index].status = 1
                }
            })
            this.setInputSelectState(1)
        },
        /**
         * 方法说明：在商品名称或者商品编号输入框中单击打开选择商品弹框
         * @method btnInputClick
         * @param {Object} e-输入框的信息包含输入框的值等
         */
        btnInputClick(e) {
            this.$refs.commodity.onOpen(this.dataSource, e)
        },
        /**
         * 方法说明：在商品名称或者商品编号输入框中双击打开选择商品弹框
         * @method btnInputDbclick
         * @param {Object} e-输入框的信息包含输入框的值等
         */
        btnInputDbclick(e) {
            this.$refs.commodity.onOpen(this.dataSource, e.target.value)
        },
        /**
         * 方法说明：在商品名称或者商品编号输入框中回车打开选择商品弹框
         * @method pressEnterSelect
         * @param {Object} e-输入框的信息包含输入框的值等
         */
        pressEnterSelect(e) {
            this.$refs.commodity.onOpen(this.dataSource, e.target.value)
            // if (this.isEmpty(e.target.value)) {
            //     this.$refs.commodity.onOpen(this.dataSource, e.target.value)
            // } else {
            //     this.checkForPresence(e.target.value)
            // }
        },
        /**
         * 方法说明：输入商品编号获取商品详情
         * @method checkForPresence
         * @param {Object} e-输入框的信息包含输入框的值等
         */
        checkForPresence(value) {
            let params = {}
            let header = {}
            let data = {
                companyStoreId: this.$store.state.userInfo.companyStoreId,
                code: this.inputData.productCode,
                productName: this.inputData.productName
            }
            productCode(params, header, data).then((res) => {
                if (res.code == 200) {
                    if (res.result) {
                        this.confirmParts([res.result])
                        this.inputData.productCode = ''
                        this.inputData.productName = ''
                    } else {
                        this.$refs.commodity.onOpen(this.dataSource, value)
                    }
                } else {
                    // this.$message.error(res.logMessage)
                    this.$refs.commodity.onOpen(this.dataSource, value)
                }
            })
        },

        /**
         * 方法说明：选择商品回调
         * @method confirmParts
         * @param {Array} data-选择商品信息的数组
         */
        confirmParts(data) {
            let arr = []
            this.skuIdList = [] // 商品属性id
            this.dataSource.map((item, index) => { // 保留当前已选择的商品
                if (item.productName) {
                    arr.push(item)
                }
            })
            this.dataSource = arr
            data.map((item, index) => { //  将未重复的添加进去
                this.dataSource.push({
                    serialNum: index,
                    assemblyFlag: item.assemblyFlag, // 是否总成 0否 1是
                    giftFlag: 0, // 是否赠品 0否 1是
                    price: '', //  价格
                    sellingPrice: Number(item.retailPrice),
                    productCode: item.code, // 商品编号
                    productId: item.id, // 商品id
                    productModel: item.model, // 产品型号
                    productName: item.name, // 商品名称
                    productSkuId: item.skuId, // 商品属性id
                    productSkuName: item.productSkuName, // 商品属性名称
                    productSpecification: item.specification, // 产品规格
                    productTotalCount: '', // 数量 
                    productUnitName: item.unit, // 单位
                    productUnitId: item.unitId,
                    stockCount: item.stockCount,
                    remark: '', // 备注
                    totalAmount: '', // 总价
                    status: 0, // 名称输入框显示隐藏控制
                    statusCode: 0, // 编号
                    isNumShow: index == 0 ? true : false, // 数量输入框显示隐藏控制
                    isPriceShow: false, // 售价输入框显示隐藏控制
                    isRemarkShow: false, // 备注输入框显示隐藏控制
                })
                this.skuIdList.push(item.skuId)
            })
            this.setDataSource()
        },

        /**
         * 方法说明：编辑销售订单详情
         * @method SelldetailsConfirmParts
         * @param {Array} data-选择商品信息的数组
         */
        SelldetailsConfirmParts(data) {
            let arr = []
            this.skuIdList = [] // 商品属性id
            this.dataSource.map((item, index) => { // 保留当前已选择的商品
                if (item.productName) {
                    arr.push(item)
                }
            })
            this.dataSource = arr
            data.map((item, index) => { //  将未重复的添加进去
                this.dataSource.push({
                    serialNum: index,
                    id: item.id, // 单据id
                    assemblyFlag: item.assemblyFlag, // 是否总成 0否 1是
                    giftFlag: item.giftFlag, // 是否赠品 0否 1是
                    price: Number(item.price), //  价格
                    productCode: item.productCode, // 商品编号
                    productId: item.productId, // 商品id
                    productModel: item.productModel, // 产品型号
                    productName: item.productName, // 商品名称
                    productSkuId: item.productSkuId, // 商品属性id
                    productSkuName: item.productSkuName, // 商品属性名称
                    productSpecification: item.productSpecification, // 产品规格
                    productTotalCount: item.productTotalCount, // 数量 
                    productUnitName: item.productUnitName, // 单位
                    productUnitId: item.productUnitId,
                    remark: item.remark, // 备注
                    totalAmount: Number(item.totalAmount), // 总价
                    status: 0, // 名称输入框显示隐藏控制
                    statusCode: 0, // 编号
                    isNumShow: false, // 数量输入框显示隐藏控制
                    isPriceShow: false, // 售价输入框显示隐藏控制
                    isRemarkShow: false, // 备注输入框显示隐藏控制
                    contactCustomerId: this.formData.contactCustomerId
                })
                this.skuIdList.push(item.productSkuId)
            })
            this.setDataSource()
        },

        /**
         * 方法说明：详情返回参数
         * @method detailsConfirmParts
         * @param {Array} data-选择商品信息的数组
         */
        detailsConfirmParts(data) {
            let arr = []
            this.skuIdList = [] // 商品属性id
            this.dataSource.map((item, index) => { // 保留当前已选择的商品
                if (item.productName) {
                    arr.push(item)
                }
            })
            this.dataSource = arr
            data.map((item, index) => { //  将未重复的添加进去
                if (!item.repetition) {
                    this.dataSource.push({
                        serialNum: index,
                        id: item.id, // 单据id
                        assemblyFlag: item.assemblyFlag, // 是否总成 0否 1是
                        giftFlag: item.giftFlag, // 是否赠品 0否 1是
                        price: parseInt(item.price), //  价格
                        productCode: item.productCode, // 商品编号
                        productId: item.productId, // 商品id
                        productModel: item.productModel, // 产品型号
                        productName: item.productName, // 商品名称
                        productSkuId: item.productSkuId, // 商品属性id
                        productSkuName: item.productSkuName, // 商品属性名称
                        productSpecification: item.productSpecification, // 产品规格
                        productTotalCount: item.productTotalCount, // 数量 
                        productUnitName: item.productUnitName, // 单位
                        productUnitId: item.productUnitId,
                        remark: item.remark, // 备注
                        priceList: [], // 预设价格列表
                        totalAmount: parseInt(item.totalAmount), // 总价
                        status: 0, // 名称输入框显示隐藏控制
                        statusCode: 0,
                        isNumShow: false, // 数量输入框显示隐藏控制
                        isPriceShow: false, // 售价输入框显示隐藏控制
                        isRemarkShow: false, // 备注输入框显示隐藏控制
                    })
                    this.skuIdList.push(item.productSkuId)
                }
            })
            this.setDataSource()
        },

        /**
         * 方法说明：设置数据
         * @method setDataSource
         * @for detailsConfirmParts, SelldetailsConfirmParts, confirmParts
         */
        setDataSource() {
            // 对金额数据格式的处理，保留两位小数
            this.dataSource.map(item => {
                item.price = this.isEmpty(item.price)? '' :this.$comm.toDecimal2(item.price)
                item.totalAmount = this.$comm.toDecimal2(this.isEmpty(item.price)? 0 :item.totalAmount)
            })
            if (this.skuIdList.length > 0) { // 获取库存数量、成本价
                this.getlistByProductSkuId()
            }
            if (this.dataSource.length < 18) { // 在数据未满8条的情况下添加空白
                for (let i = this.dataSource.length; i < 18; i++) {
                    this.dataSource.push({
                        serialNum: i,
                        status: 1,
                        statusCode: 1
                    })
                }
            } else {
                this.dataSource.push({
                    serialNum: this.dataSource.length+1,
                    status: 1,
                    statusCode: 1
                })
            }
            this.tableAddTotalRow(this.columns, this.dataSource) // 计算总价
        },

        /**
         * 方法说明：获取库存数量、成本价
         * @method getlistByProductSkuId
         * @for setDataSource
         */
        getlistByProductSkuId() {
            let header = {}
            let data = {
                companyStoreId: this.$store.state.userInfo.companyStoreId
            }
            listByProductSkuId(this.skuIdList, header, data).then((res) => {
                if (res.success) {
                    res.result.map((item, index) => {
                        this.dataSource.map((ite, inde) => {
                            if (item.id == ite.productSkuId) {
                                ite.costPrice = item.costPrice
                                ite.stockCount = item.stockCount
                                this.dataSource.splice(inde, 1, ite)
                            }
                        })
                    })
                }
            })
        },

        /**
         * 方法说明：改变文本为输入框
         * @method btnShowInput
         * @param {Object, Number, Number} record-选择商品信息; index: 选择商品下标; 
         *      type: 点击表格类型—— 5：点击单位表格；7：点击数量表格；8：点击售价表格；9：点击出库库位表格；10：点击备注
         */
        btnShowInput(record, index, type) {
            if (this.tdIndex == index || this.tdIndex == null) {
                if (type == 7) { // 点击数量表格
                    this.dataSource[index].isNumShow = true
                } else if (type == 8) { // 点击售价表格
                    if (this.isEmpty(record.productTotalCount)) {
                        this.$message.warning('请先输入商品数量')
                        return
                    }
                    if (record.giftFlag == 0) {
                        this.selectOpen = false
                        this.dataSource[index].isPriceShow = true
                        this.locationleft = document.getElementById('price-list-location').parentElement.offsetLeft
                    } else {
                        this.$message.warning('选择商品已被设置为赠品，价格不能改变')
                    }
                } else if (type == 10) { // 点击备注
                    if (this.isEmpty(record.price)) {
                        this.$message.warning('请先输入商品价格')
                        return
                    }
                    this.dataSource[this.tdIndex].isPriceShow = false
                    this.dataSource[index].isRemarkShow = true
                }
                this.dataSource.splice(index, 1, this.dataSource[index])
                this.tdIndex = index
            } else {
                if (type == 7) { // 点击数量表格
                    this.dataSource[this.tdIndex].isNumShow = false
                    this.dataSource[index].isNumShow = true
                } else if (type == 8) { // 点击售价表格
                    if (this.isEmpty(record.productTotalCount)) {
                        this.$message.warning('请先输入商品数量')
                        return
                    }
                    if (record.giftFlag == 0) {
                        this.selectOpen = false
                        this.dataSource[this.tdIndex].isPriceShow = false
                        this.dataSource[index].isPriceShow = true
                        this.locationleft = document.getElementById('price-list-location').parentElement.offsetLeft
                    } else {
                        this.$message.warning('选择商品已被设置为赠品，价格不能改变')
                    }
                } else if (type == 10) { // 点击备注
                    if (this.isEmpty(record.price)) {
                        this.$message.warning('请先输入商品价格')
                        return
                    }
                    this.dataSource[this.tdIndex].isPriceShow = false
                    this.dataSource[this.tdIndex].isRemarkShow = false
                    this.dataSource[index].isRemarkShow = true
                }
                this.dataSource.splice(index, 1, this.dataSource[index])
                this.tdIndex = index
            }
            this.setInputSelectState(type)
        },

        /**
         * 方法说明：改变其他输入或选择框状态
         * @method setInputSelectState
         * @param {Number} e-选择单位下标; 
         */
        setInputSelectState(type) {
            this.dataSource.map((item, index) => {
                if (type == 7) {
                    item.isPriceShow = false
                    item.isRemarkShow = false
                } else if (type == 8) {
                    item.isNumShow = false
                    item.isRemarkShow = false
                } else if (type == 10) {
                    item.isNumShow = false
                    item.isPriceShow = false
                } else {
                    item.isNumShow = false
                    item.isPriceShow = false
                    item.isRemarkShow = false
                }
            })
        },

        /**
         * 方法说明：输入数量
         * @method btnChangeNumber
         * @param {Object} record-选择商品信息
         */
        btnChangeNumber(record) {
            if (this.isEmpty(record.productTotalCount)) {
                return
            }
            record.totalAmount = Number(record.productTotalCount) * Number(record.price)
            record.totalAmount = record.totalAmount.toFixed(2)
            this.tableAddTotalRow(this.columns, this.dataSource)
        },

        /**
         * 方法说明：输入价格
         * @method btnInputPrice
         * @param {Object} record-选择商品信息;
         */
        btnInputPrice(record) {
            if (this.isEmpty(record.price)) {
                return
            }
            record.price = (record.price.match(/^\d*(\.?\d{0,2})/g)[0]) || null
            record.totalAmount = record.price * record.productTotalCount
            record.totalAmount = record.totalAmount.toFixed(2)
            this.tableAddTotalRow(this.columns, this.dataSource)
        },
        /**
         * 方法说明：打开选择价格下拉框
         * @method btnOpenPriceSelect
         * @param {Object,Number} record-选择商品信息; index: 选择商品的下标
         */
        btnOpenPriceSelect(record, index) {
            this.selectOpen = !this.selectOpen
            if (this.selectOpen) {
                this.$refs.selectprice.open(record, index)
            } else {
                this.$refs.selectprice.cancel()
            }
        },
        /**
         * 方法说明：关闭选择价格下拉框
         * @method btnCancelPrice
         * @param {Number} index-选择商品的下标
         */
        btnCancelPrice(index) {
            this.selectOpen = false
            this.dataSource[index].isPriceShow = false
            this.btnShowInput(this.dataSource[index], index, 10)
        },
        /**
         * 方法说明：选择预售价格
         * @method btnSelectPrice
         * @param {Object} item-选择价格信息
         */
        btnSelectPrice(item) {
            this.dataSource[item.index].price = item.price
            this.dataSource[item.index].isPriceShow = false
            this.btnShowInput(this.dataSource[item.index], item.index, 10)
            this.btnChangeNumber(this.dataSource[item.index])
        },
        /**
         * 方法说明：点击任何位置关闭选择价格框
         * @method closeIconBlock
         */
        closeIconBlock() {
            this.dataSource[this.tdIndex].isPriceShow = false
        },
        /**
         * 方法说明：输入完备注后回车聚焦到下一条信息
         * @method btnShowInputRemark
         * @param {Number,Number} text-输入备注; index: 选择商品的下标
         */
        btnShowInputRemark(text, record, index) {
            if (this.dataSource[index + 1].productName) {
                this.btnShowInput(this.dataSource[index + 1], index + 1, 7)
            } else {
                this.btnChangeState(text, this.dataSource[index + 1], index + 1)
            }
        },

        /**
         * 方法说明：设置为赠品
         * @method btnComplimentary
         * @param {Object} record-选择商品信息
         */
        btnComplimentary(record) {
            record.giftFlag = '1'
            if (record.giftFlag == 1) {
                record.backupsPrice = record.price
                record.backupsTotalAmount = record.totalAmount
                record.price = 0
                record.totalAmount = 0
            }
            // if (record.businessVoucherId) {
            //     record.VoucherId = record.businessVoucherId
            //     record.VoucherCode = record.businessVoucherCode
            //     delete record.businessVoucherId
            //     delete record.businessVoucherCode
            // }
            this.tableAddTotalRow(this.columns, this.dataSource)
        },
        /**
         * 方法说明：取消设置赠品
         * @method btnCancelSetup
         * @param {Object} record-选择商品信息
         */
        btnCancelSetup(record) {
            record.giftFlag = '0'
            if (record.giftFlag == 0) {
                record.price = record.backupsPrice ? record.backupsPrice : this.$comm.toDecimal2(0)
                record.totalAmount = record.backupsTotalAmount ? record.backupsTotalAmount : this.$comm.toDecimal2(0)
            }
            // if (record.VoucherId) {
            //     record.businessVoucherId = record.VoucherId
            //     record.businessVoucherCode = record.VoucherCode
            //     delete record.VoucherId
            //     delete record.VoucherCode
            // }
            this.tableAddTotalRow(this.columns, this.dataSource)
        },

        /**
         * 方法说明：查看历史记录
         * @method btnHistoryPrice
         * @param {Object} record-选择商品信息
         */
        btnHistoryPrice(record) {
            if (this.isEmpty(this.formData.contactCustomerId)) {
                this.$message.warning('请先选择往来单位')
                return;
            }
            this.$refs.history.open(record.productSkuId, this.formData.contactCustomerId)
        },

        /**
         * 方法说明：添加行
         * @method btnAddTd
         */
        btnAddTd() {
            this.dataSource.push({
                status: 1
            })
        },
        /**
         * 方法说明：删除行
         * @method btnDelTd
         * @param {Number} index: 选择商品的下标
         */
        btnDelTd(index) {
            this.dataSource.splice(index, 1)
            if (this.dataSource.length < 18) {
                for (let i = this.dataSource.length; i < 18; i++) {
                    this.dataSource.push({
                        serialNum: i,
                        status: 1,
                        statusCode: 1
                    })
                }
            } else {
                this.dataSource.push({
                    serialNum: this.dataSource.length+1,
                    status: 1,
                    statusCode: 1
                })
            }
            this.tableAddTotalRow(this.columns, this.dataSource)
        },

        /**
         * 方法说明：选择是否送货上门
         * @method changeLogistics
         * @param {Object} e: 物流方式选择回调信息 
         */
        changeLogistics(e) {
            this.formData.distributionMode = e.target.value
        },
        /**
         * 方法说明：打开选择物流公司的弹框
         * @method btnLogistics
         */
        btnLogistics() {
            this.$refs.popover.show()
        },
        /**
         * 方法说明：选择物流公司回调
         * @method getlogisticsinfo
         * @param {Object} data: 物流公司信息
         */
        getlogisticsinfo(data, type) {
            this.formData.logisticsCompanyId = data.id
            this.formData.logisticsCompanyName = data.name
        },

        /**
         * 方法说明：选择是否含运费
         * @method onChangeFreight
         * @param {Object} e:选择信息
         */
        onChangeFreight(e) {
            this.includeFreightFlag = e.target.checked
        },

        /**
         * 方法说明：选择加收费用回调
         * @method btnSelectAdded
         */
        btnSelectAdded() {
            if (this.isEmpty(this.formData.otherExpensesAmount)) {
                this.formData.salesPriceOtherExpensesVOList = []
                this.formData.salesOrderOtherExpensesVOList = []
            } else {
                this.formData.otherExpensesAmount = Number(this.formData.otherExpensesAmount)
                if (this.formData.salesOrderOtherExpensesVOList && this.formData.salesOrderOtherExpensesVOList.length > 0) {
                    this.formData.salesOrderOtherExpensesVOList[0].amount = this.formData.otherExpensesAmount
                } else if (this.formData.salesOrderOtherExpensesVOList) {
                    this.formData.salesOrderOtherExpensesVOList.push({
                        otherIncomeExpenditureCategoryId: '1322077413496328194',
                        otherIncomeExpenditureCategoryName: '',
                        amount: this.formData.otherExpensesAmount
                    })
                }
                if (this.formData.salesPriceOtherExpensesVOList && this.formData.salesPriceOtherExpensesVOList.length > 0) {
                    this.formData.salesPriceOtherExpensesVOList[0].amount = this.formData.otherExpensesAmount
                } else if (this.formData.salesPriceOtherExpensesVOList) {
                    this.formData.salesPriceOtherExpensesVOList.push({
                        otherIncomeExpenditureCategoryId: '1322077413496328194',
                        otherIncomeExpenditureCategoryName: '',
                        amount: this.formData.otherExpensesAmount
                    })
                }
            }
            this.tableAddTotalRow(this.columns, this.dataSource)
        },

        /**
         * 方法说明：设置优惠金额
         * @method btnDiscountAmount
         */
        btnDiscountAmount() {
            if (this.isEmpty(this.formData.discountAmount)) {
                this.formData.discountAmount = 0
                this.tableAddTotalRow(this.columns, this.dataSource)
            } else {
                if (this.formData.totalAmount > this.formData.discountAmount) {
                    this.tableAddTotalRow(this.columns, this.dataSource)
                } else {
                    this.$message.warning('您设置的优惠金额大于实收金额')
                    this.formData.discountAmount = null
                }
            }
        },

        /**
         * 方法说明：底部按钮点击回调
         * @method onClickButton
         * @param {Object} item: 点击按钮信息
         */
        onClickButton(item) {
            if (item.id == 1) { // 点击取消退出
                this.$refs.footer.testingRequired(item.id)
            } else if (item.id == 300) { // 点击调入报价
                this.$refs.offerorder.open({
                    contactCustomerId: this.formData.contactCustomerId,
                    selectVoucherId: this.selectVoucherId,
                    agentList: this.agentList,
                    contactCustomerName: this.formData.contactCustomerName
                })
            } else { // 验证必填数据是否填写
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        if (this.dataSource[0].productName) {
                            let issubmit = true
                            this.dataSource.map((item, index) => {
                                if (item.productName) {
                                    if (this.isEmpty(item.productTotalCount)) {
                                        issubmit = false
                                    }
                                }
                            })
                            if (issubmit) {
                                this.tableAddTotalRow(this.columns, this.dataSource)
                                this.$refs.footer.testingRequired(item.id)
                            } else {
                                this.$message.warning("请给选择的商品设置数量")
                            }
                        } else {
                            this.$message.warning("请先选择商品")
                        }
                    } else {
                        return false;
                    }
                })
            }
        },

        /**
         * 方法说明：计算总金额
         * @method CalculationAmount
         * @for tableAddTotalRow
         */
        CalculationAmount(totalRow) {
            let otherExpensesAmount = 0
            let discountAmount = 0
            if (this.formData.otherExpensesAmount) {
                otherExpensesAmount = Number(this.formData.otherExpensesAmount)
            }
            if (this.formData.discountAmount) {
                discountAmount = Number(this.formData.discountAmount)
            }
            this.formData.totalAmount = Number(totalRow.totalAmount) + otherExpensesAmount - discountAmount
            this.formData.productTotalCount = totalRow.productTotalCount
        },

        /**
         * 方法说明：导入单据
         * @method btnOnCofrim
         * @param {String, Number} id: 单据id； type：单据类型
         */
        btnOnCofrim(id, type) {
            if (type == 1) {
                this.mackeId = id
                this.getDetailsMakeData()
            }
        },
        /**
         * 方法说明：报价详情
         * @method getDrafDetailsData
         */
        getDetailsMakeData() {
            let params = new FormData()
            params.append("salesPriceId", this.mackeId)
            this.$store.state.isLoding = true
            getDetailsMethod(this.urlList.details, params).then((res) => {
                if (res.code == 200) {
                    this.formData = res.result // 返回数据
                    this.formData.transactorId = this.isEmpty(res.result.transactorId) ? undefined : res.result.transactorId; // 经办人id
                    this.formData.transactorName = this.isEmpty(res.result.transactorName) ? undefined : res.result.transactorName; // 经办人名称
                    this.includeFreightFlag = res.result.includeFreightFlag == 0 ? true : false // 是否包含运费
                    if (this.formData.attachmentResourceList.length > 0) { // 获取附件中的文件id
                        this.formData.attachmentResourceList.map(item => {
                            this.formData.attachmentResourceIdList.push(item.resourceId)
                        })
                    }
                    this.dataSource = []
                    this.voucherDate = moment(res.result.voucherDate)
                    this.detailsConfirmParts(res.result.salesPriceItemVOList) // 将商品数据导入表格
                    document.getElementById('steps-01').focus() // 往来单位去掉必填提示
                    setTimeout(function () {
                        document.getElementById('steps-01').blur()
                    }, 10);
                    this.$store.state.isLoding = false // 结束加载动画
                } else {
                    this.$message.error(res.logMessage)
                }
            })
        },
    }
}